<span
  class="day"
  [attr.data-id]="day.date"
  [attr.data-name]="'day'"
  [attr.data-can-drop]="day.isAvailableForDelivery"
  [ngClass]="{ today: day.isToday, selected: day.date.isSame(selectedDay), weekend: day.isWeekend, unavailable: !day.isAvailableForDelivery }"
  (click)="showFlorderModal.emit(day)"
>
<!--  [dragula]="'templates-bag'"-->
  <div class="day_inner" cdkDropList [cdkDropListDisabled]='!day.isAvailableForDelivery' [cdkDropListData]='day'>
    <span>{{ day.number }}</span>
    <span class="month_starting" *ngIf="day.number === 1">{{ getMonthAbbreviation() }}</span>
    <div class="orders_wrapper">
      <app-calendar-florder-info-list class="orders_list" [day]="day" [customers]="customers" [tooltipRef]="tooltipRef" (openFlorder)="openFlorder.emit($event)">
      </app-calendar-florder-info-list>
    </div>
  </div>
</span>
